const bundleMixin = {
    methods: {
        orderBundle(bundle_id) {
            let data = {
                bundle: bundle_id,
                qty: 1
            }
            axios({
                method: 'POST',
                url: `/api/v1/cartbundleitems`,
                headers: {
                    'X-CSRFToken': window.csrfToken
                },
                data: data
            }).then((response) => {
                // console.log(window.urls.orderBundles)
                window.location.href = window.urls.orderBundles;
            }).catch((error) => {
                // handle error
            })
        }
    }
}